import { ApiError, listTemplates, type Template } from "@/api";
import { Badge } from "@/components/ui/Badge";
import { EVENT_TYPE_LABEL, MESSAGE_PHASE_LABEL, typeTone } from "@/lib/labels";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function TemplatesPage() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<Template[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    listTemplates()
      .then((tpl) => {
        if (cancelled) return;
        setTemplates(tpl);
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof ApiError ? err.message : "Vorlagen konnten nicht geladen werden.");
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="mx-auto w-full max-w-5xl px-4 py-4">
      <h1 className="mb-4 text-base font-semibold">Vorlagen</h1>
      {error ? <p className="mb-3 text-sm text-danger">{error}</p> : null}

      {templates === null && !error ? (
        <div className="mb-6 h-16 animate-pulse rounded-md bg-surface-subtle" />
      ) : null}
      {templates && templates.length === 0 ? (
        <p className="mb-6 text-sm text-muted">Noch keine Vorlagen.</p>
      ) : null}
      {templates && templates.length > 0 ? (
        <ul className="divide-y divide-hairline overflow-hidden rounded-lg border border-hairline bg-surface">
          {templates.map((template) => (
            <li key={template.id} className="flex items-center gap-3 px-3 py-2">
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-medium">{template.title}</div>
                <div className="truncate text-[11px] text-muted">
                  {template.subject_de || template.subject_en}
                </div>
              </div>
              {template.event_type ? (
                <Badge tone={typeTone(template.event_type)}>{EVENT_TYPE_LABEL[template.event_type]}</Badge>
              ) : null}
              <Badge>{MESSAGE_PHASE_LABEL[template.phase]}</Badge>
              {template.built_in ? <span className="text-[11px] text-muted">Standard</span> : null}
              <button
                type="button"
                className="text-xs text-accent hover:underline"
                onClick={() => navigate("/mails/new", { state: { templateId: template.id } })}
              >
                Mail daraus
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
